import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeRequestHelper  {
    _originalTypeClassName = "zSHR.BO.EmployeeRequestHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeRequestHelper.translate = translateService;
}
this.EmployeeRequestHelperKey = null;
this._key = this.EmployeeRequestHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _EmployeeRequestHelperKey:any;
get EmployeeRequestHelperKey(): any {
    return this._EmployeeRequestHelperKey;
  }
set EmployeeRequestHelperKey(value: any) {
    this._EmployeeRequestHelperKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmployeeRequestHelperKey == null || $this.EmployeeRequestHelperKey == 0;
            }


}